
import { defineComponent } from "vue"; //, inject, onMounted, ref } from "vue";

export default defineComponent({
	name: "App",
});
